import { render, staticRenderFns } from "./ItensListModal.vue?vue&type=template&id=f2596990&scoped=true"
import script from "./ItensListModal.vue?vue&type=script&lang=js"
export * from "./ItensListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2596990",
  null
  
)

export default component.exports